import { DOCUMENT } from '@angular/common';
import {
    HttpEvent,
    HttpEventType,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import {
    Inject,
    Injectable,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { FeatureFlag } from '@models';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

/**
 * Handle maintenance mode
 */
@Injectable()
export class HttpMaintenanceInterceptor implements HttpInterceptor {

    constructor(
        private _appState: AppStateFacade,
        @Inject(DOCUMENT) private _document: Document,
    ) { }

    /**
     * Intercept responses when in Maintenance Mode and redirect to a static page.
     *
     * @param {HttpRequest<any>} req
     * @param {HttpHandler} next
     * @return {Observable<HttpEvent<any>>}
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const maintenanceHeader = 'X-UIPATH-Maintenance';

        return next.handle(request).pipe(
            tap(event => {
                if (event.type === HttpEventType.Response &&
                    event.headers.has(maintenanceHeader)) {
                    this._performMaintenanceRedirect();
                }
            }),
        );
    }

    // OR-14182
    private _performMaintenanceRedirect() {
        if (this._appState.settings.isFeatureEnabled(FeatureFlag.Maintenance)) {
            (this._document.defaultView || window).location.href = '/maintenance' ;
        }
    }
}
